import type { ResultOf } from '@/lib/gql';
import { graphql } from '@/lib/gql';

const LOCATION_FRAGMENT = graphql(`
  fragment Location on GeoJson {
    type
    point {
      lng
      lat
    }
    lineString {
      lng
      lat
    }
    polygon {
      lng
      lat
    }
    multiPolygon {
      lng
      lat
    }
  }
`);

export const locationToPoint = (location: ResultOf<typeof LOCATION_FRAGMENT>) => {
  switch (location?.type) {
    case 'LINE_STRING':
      if (!location.lineString) return undefined;

      return location.lineString[0];

    case 'POLYGON':
      if (!location.polygon) return undefined;

      return location.polygon[0][0];

    case 'MULTIPOLYGON':
      if (!location.multiPolygon) return undefined;

      return location.multiPolygon[0][0][0];

    case 'POINT':
      return location.point;

    default:
      return undefined;
  }
};
